import {EmailValidator} from "./email-validator";
import {LreRecipient} from "./lre-recipient";

export class PostalAddress {
  id: number;
  sCountryID: string;
  sElem: string[];
  addrStruct: string[][];
  mElemByName: any;
  iNbLinesMax: number;
  sUpperCaseLines: string;
  addressEmpty: boolean;
  valid: boolean;
  validIdentityRecipient: boolean;
  spoolFileName: string;
  pageCount: string;
  fields: PostalAddressFields;
  lines: string[];
  formatted: string[];
  userFields: any;
  recipientMail: string;
  recipient: LreRecipient;

  constructor(object: any) {
    this.id = object.id ? object.id : '';
    this.sCountryID = object.sCountryID ? object.sCountryID : '';
    this.spoolFileName = object.spoolFileName ? object.spoolFileName : '';
    this.pageCount = object.pageCount ? object.pageCount : '';
    this.sElem = object.sElem ? object.sElem : [];
    this.addrStruct = object.addrStruct ? object.addrStruct : null;
    this.mElemByName = object.mElemByName ? object.mElemByName : {};
    this.iNbLinesMax = object.iNbLinesMax ? object.iNbLinesMax : 7;
    this.sUpperCaseLines = object.sUpperCaseLines ? object.sUpperCaseLines : '';
    this.addressEmpty = object.adressEmpty ? object.adressEmpty : true;
    this.valid = object.valid ? object.valid : false;
    this.validIdentityRecipient = object.validIdentityRecipient ? object.validIdentityRecipient : false;
    this.lines = object.lines ? object.lines : [];
    this.formatted = object.formatted ? object.formatted : [];
    this.fields = new PostalAddressFields(object.fields);
    this.userFields = object.userFields;
    this.recipientMail = object.recipientMail ? object.recipientMail : null;
    this.recipient = object.recipient ? object.recipient : null;
    if(object.recipient) {
      this.recipient.address = object.formatted ? object.formatted : [];
    }
  }

  public isValid(): boolean {
    return this.valid;
  }
  public isValidIdentityRecipient(): boolean {
    return this.validIdentityRecipient;
  }
  public isValidMail(): boolean {
    return EmailValidator.emailIsValid(this.recipientMail);
  }

  public formatAddress(): string {
    let result = '';
    let first = true;
    for (const line of this.formatted) {
      if (line && line !== '') {
        if (first) {
          result = line;
          first = false;
        } else {
          result = result + ', ' + line;
        }
      }
    }
    return result;
  }
}

export class PostalAddressFields {
  recipient: string;
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  constructor(object: any) {
    if (object) {
      this.recipient = object.recipient ? object.recipient : '';
      this.line1 = object.line1 ? object.line1 : '';
      this.line2 = object.line2 ? object.line2 : '';
      this.line3 = object.line3 ? object.line3 : '';
      this.line4 = object.line4 ? object.line4 : '';
      this.postalCode = object.postalCode ? object.postalCode : '';
      this.city = object.city ? object.city : '';
      this.country = object.country ? object.country : '';
    }
  }
}
